import type { TeamMember } from '@/api/commercialDashboardApi'

const amountFormatter = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
})

export function formatAmount(amount: number): string {
  return amountFormatter.format(amount ?? 0)
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function memberFullName(member: TeamMember['user']): string {
  return `${member.firstName ?? ''} ${member.lastName ?? ''}`.trim() || member.email
}
